export default __webpack_public_path__ + "static/media/unique-interior-design-possibilities.36fb001a.svg";